export default __webpack_public_path__ + "static/media/iphone-8.53d23eba.png";